import { useEffect, useState } from "react";

const ROLE_OPTIONS = [
  {
    value: "BUSINESS_OWNER",
    label: "Business owner",
    description: "Full control over the business.",
  },
  {
    value: "ADMIN",
    label: "Admin",
    description: "Manage team members and operations.",
  },
  {
    value: "AGENT",
    label: "Agent",
    description: "Limited access for field operations.",
  },
];

export default function RoleManagerModal({ roles, onClose, onSave, submitting, disableOwnerRemoval }) {
  const [selected, setSelected] = useState(() => new Set((roles || []).filter(Boolean)));

  useEffect(() => {
    const next = new Set((roles || []).filter(Boolean));
    if (disableOwnerRemoval) {
      next.add("BUSINESS_OWNER");
    }
    setSelected(next);
  }, [roles, disableOwnerRemoval]);

  const toggleRole = (role) => {
    if (disableOwnerRemoval && role === "BUSINESS_OWNER") return;
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(role)) next.delete(role);
      else next.add(role);
      return next;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(Array.from(selected));
  };

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100" style={{ background: "rgba(17,24,39,.45)", zIndex: 1200 }}>
      <div className="d-flex w-100 h-100 justify-content-center align-items-center p-3 p-sm-4">
        <section className="ui-panel w-100" style={{ maxWidth: 560 }}>
          <header className="ui-panel__header">
            <div className="d-flex align-items-center justify-content-between">
              <h3 className="ui-title mb-0">Update roles</h3>
              <button className="ui-btn" type="button" onClick={onClose} disabled={submitting}>
                Close
              </button>
            </div>
            <p className="ui-subtitle mb-0">
              Enable or revoke roles for this user. Owners always keep their BUSINESS_OWNER role.
            </p>
          </header>
          <form onSubmit={handleSubmit}>
            <div className="p-3 p-md-4 d-flex flex-column gap-3">
              {ROLE_OPTIONS.map((role) => {
                const checked = selected.has(role.value);
                const disabled = submitting || (disableOwnerRemoval && role.value === "BUSINESS_OWNER");
                return (
                  <label
                    key={role.value}
                    className={`border rounded-4 p-3 d-flex flex-column gap-1 ${checked ? "bg-body-tertiary" : ""}`}
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={checked}
                        disabled={disabled}
                        onChange={() => toggleRole(role.value)}
                      />
                      <span className="fw-semibold">{role.label}</span>
                    </div>
                    <small className="text-body-secondary">{role.description}</small>
                  </label>
                );
              })}
            </div>
            <div className="ui-actions px-3 px-md-4 pb-3 pb-md-4 w-100 justify-content-end gap-2">
              <button type="button" className="ui-btn" onClick={onClose} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="btn btn-success rounded-pill" disabled={submitting}>
                {submitting ? "Saving…" : "Save roles"}
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
}
